import * as Yup from "yup"
import { matchingDecimal, matchingNumber, notice_disponibilite } from "../../config/helpers";
import { MESSAGE_ERREUR_ENTIER_VALEUR_POSITIF, MESSAGE_ERREUR_VALEUR_POSITIF } from "../../pages/FO/components/Notice/NoticeAutoMessage";
// import { formatDate } from "../../utils/helpers";
// import { format } from 'date-fns';
//import { AnyObject, string, StringSchema } from "yup"
//import { MESSAGE_ERREUR_CONFIRMATION_EMAIL_FORMAT, MESSAGE_ERREUR_CONFIRMATION_EMAIL_NON_CORRESPONDANT, MESSAGE_ERREUR_CONFIRMATION_EMAIL_OBLIGATOIRE, MESSAGE_ERREUR_EMAIL_FORMAT, MESSAGE_ERREUR_EMAIL_OBLIGATOIRE, MESSAGE_ERREUR_EMAILNEW_EMAIL_IDENTIQUES } from "../../data/message-erreurs-form" 

const checkNumberPositif = (messageErreur:string) =>
  Yup.string()
    .matches(matchingDecimal, messageErreur)
    .test("number_positif", messageErreur, (value) => !value || Number(value.replace(',', '.')) >= 0);

    const checkNumberEntierPositif = (messageErreur:string) =>
      Yup.string()
        .matches(matchingNumber, messageErreur)
        .test("number_entier_positif", messageErreur, (value) => !value || Number(value) >= 0);
  
export const DemandeNoticeAutoSchema = Yup.object().shape({
  // Champs `Old` optionnels
  hauteur: Yup.string(), 
  largeur: Yup.string(),
  epaisseur: Yup.string(),
  poids: Yup.string(),
  nbpages: Yup.string(),
  disponibilite: Yup.string(),
  prixttc: Yup.string(),
  dateparution: Yup.string(),


  // Champs `New`
  hauteurNew: checkNumberPositif(MESSAGE_ERREUR_VALEUR_POSITIF),
  largeurNew: checkNumberPositif(MESSAGE_ERREUR_VALEUR_POSITIF),
  epaisseurNew: checkNumberPositif(MESSAGE_ERREUR_VALEUR_POSITIF),
  poidsNew: checkNumberEntierPositif(MESSAGE_ERREUR_ENTIER_VALEUR_POSITIF),
  nbpagesNew: checkNumberEntierPositif(MESSAGE_ERREUR_ENTIER_VALEUR_POSITIF),
  disponibiliteNew: Yup.string().nullable(),
  prixttcNew: checkNumberPositif(MESSAGE_ERREUR_VALEUR_POSITIF),
  dateparutionNew: Yup.string().nullable(),
  
  ErreurMsg: Yup.string()
})
// Test Général : Au moins un champ `New` doit être rempli
.test('validate-at-least-one-new-field', 'Au moins un des champs doit être rempli', function (value) {
  const newFields = [
    value?.hauteurNew,
    value?.largeurNew,
    value?.epaisseurNew,
    value?.poidsNew,
    value?.nbpagesNew,
    value?.prixttcNew,
    value?.dateparutionNew,
    value?.disponibiliteNew,
  ];

  const isEmpty = newFields.every(field => !field || field?.toString().trim() === "");
  if (isEmpty) {
    return new Yup.ValidationError('Au moins un des champs doit être rempli',null,'ErreurMsg');
  }
  return true; // Validation réussie
})
.test('validate-all', '', 
  function (values,context) {

    const { disponibilite, disponibiliteNew, dateparutionNew, prixttc, prixttcNew } = values || {};
    const errors: Yup.ValidationError[] = [];
    const now = new Date();
    const _dateparutionNew = dateparutionNew ? new Date(dateparutionNew) : null; 
    const _dateNow =now;

    //Disponibilité modifiée
    if (disponibilite !== "" && disponibilite !== notice_disponibilite.AParaitre.toString()) {
      if (disponibiliteNew !== "" && disponibiliteNew === notice_disponibilite.AParaitre.toString()) {
        errors.push(
          context.createError({
            path: 'disponibiliteNew',
            message: 'Nouvelle disponibilité incohérente avec l\'ancienne.',
          })
        );
      }
    }
    //#1550- Modification guidées : rendre le prix obligatoire si MAJ avec dispo différente de "A paraître"
    // Validation du prix TTC pour un livre paru
    const finalDisponibilite = disponibiliteNew !== "" ? disponibiliteNew : disponibilite;
    if (finalDisponibilite !== "" && finalDisponibilite !== notice_disponibilite.AParaitre.toString()) {
      // Si la disponibilité finale n'est pas "A Paraître", le prix est obligatoire
      const hasPrix = (prixttc && prixttc.toString().trim() !== "") || (prixttcNew && prixttcNew.toString().trim() !== "");
      if (!hasPrix) {
        errors.push(
          context.createError({
            path: 'prixttcNew',
            message: 'Le prix TTC / Valeur demandée est obligatoire pour un livre paru.',
          })
        );
      }
    }

    //Incohérence avec la date de parution
    if (_dateparutionNew !== null) {
      if (
        disponibiliteNew !== notice_disponibilite.AParaitre.toString() 
        && disponibiliteNew !== ""
        && disponibilite === notice_disponibilite.AParaitre.toString()
        && _dateparutionNew > _dateNow
      ) {
        errors.push(
          context.createError({
            path: 'dateparutionNew',
            message: 'La date de parution doit être antérieure ou égale à la date du jour.',
          })
        );
      }
    }
    if (_dateparutionNew !== null ) {
      if (
        ((disponibilite !== "" && disponibilite !== notice_disponibilite.AParaitre.toString())
        )
      ) {
        errors.push(
          context.createError({
            path: 'dateparutionNew',
            message: 'Le changement de date de parution n’est pas autorisé pour une notice déjà parue',
          })
        );
      }
    }

    if (_dateparutionNew !== null) {
      if (
        (disponibiliteNew === notice_disponibilite.AParaitre.toString()
        || (disponibiliteNew === "" && disponibilite === notice_disponibilite.AParaitre.toString())
        )
        && _dateparutionNew <= _dateNow
      ) {
        errors.push(
          context.createError({
            path: 'dateparutionNew',
            message: 'La date de parution doit être postérieure à la date du jour.',
          })
        );
      }
    }

    if (errors.length > 0) {
      return new Yup.ValidationError(errors);
    }

    return true; // Validation réussie

 }
)

